import { getPresets } from '@indriver/vandermeer';
import styled from '../../../node_modules/.pnpm/@linaria_react@3.0.0-beta.15_react@17.0.2/node_modules/@linaria/react/esm/styled.js';
import { postfixContainerPreset } from './preset.js';

var postfixStyle = getPresets(postfixContainerPreset, {
  width: 'size',
  height: 'size'
});
var PostFixContainer = /*#__PURE__*/styled("div")({
  name: "PostFixContainer",
  class: "p11p0s8n",
  vars: {
    "p11p0s8n-0": [postfixStyle.height]
  }
});

export { PostFixContainer };


require('../../../../styles-linaria/cell/components/postfix/postfix.styles.css');
